import React, { useEffect } from "react";

const AssignPermissionHeader = ({ roleData, setIsMenu, setFilterData }) => {
  const [selectedRole, setSelectedRole] = React.useState(6);
  useEffect(() => {
    setFilterData(selectedRole);
  }, [selectedRole]);
  roleData?.sort((a, b) => a.role_name.localeCompare(b.role_name));
  return (
    <div className="relative mt-3 flex flex-col items-baseline gap-6">
      <div className=" flex w-full items-stretch justify-between gap-4 text-neutral-600">
        <div className="flex max-[380px]:w-[110px] min-[380px]:w-[120px]  flex-col gap-3 ">
          <label className="text-[14px]  font-[400] text-[#868686]">
            Role Name
          </label>
          <select
            className="flex h-full w-full flex-col gap-2 rounded-[4px] bg-gray-100 px-2 py-[0.4rem] text-[14px] text-[#868686]  focus:outline-none"
            value={selectedRole}
            onChange={(e) => setSelectedRole(Number(e.target.value))}
          >
            {roleData &&
              roleData?.map((item) => (
                <option value={item.id}>{item?.role_name}</option>
              ))}
          </select>
        </div>
        <div className=" flex w-fit items-stretch justify-between gap-4 text-neutral-600">
          <div className="mt-auto flex w-fit flex-col gap-3 ">
            <button
              className="flex items-center gap-2 rounded border-[1px] border-[#636363] max-[380px]:px-1 min-[380px]:px-2 py-1 font-bold text-[#636363]"
              onClick={() => setIsMenu(true)}
            >
              Manage Menu & Sub Menu
            </button>
          </div>
          {/* <div className="mt-auto flex w-fit  flex-col gap-3 ">
            <button
              className="flex items-center gap-2 rounded border-[1px] border-[#636363] px-2 py-1 font-bold text-[#636363]"
              //   onClick={action.actionHandler}
            >
              Update Roles & Permissions
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AssignPermissionHeader;
